import React from 'react';

// Logo Option 1: Traditional Kalash (Current)
export const LogoKalash = ({ className = "w-14 h-14" }) => (
  <svg viewBox="0 0 60 60" className={className}>
    <circle cx="30" cy="30" r="28" fill="url(#kalashGradient)" />
    <circle cx="30" cy="30" r="25" fill="none" stroke="#FDF6E3" strokeWidth="1" opacity="0.3" />
    <path 
      d="M30 12 L30 16 M26 16 Q26 14 30 14 Q34 14 34 16 L34 16 
         M22 20 Q22 16 30 16 Q38 16 38 20 
         L40 32 Q40 36 38 38 L38 40 Q38 44 30 46 Q22 44 22 40 L22 38 Q20 36 20 32 Z" 
      fill="none" stroke="#FDF6E3" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"
    />
    <path d="M30 16 Q28 10 24 8" fill="none" stroke="#D4A853" strokeWidth="1.5" strokeLinecap="round" />
    <path d="M30 16 Q30 9 30 6" fill="none" stroke="#D4A853" strokeWidth="1.5" strokeLinecap="round" />
    <path d="M30 16 Q32 10 36 8" fill="none" stroke="#D4A853" strokeWidth="1.5" strokeLinecap="round" />
    <circle cx="24" cy="8" r="1.5" fill="#D4A853" />
    <circle cx="30" cy="6" r="1.5" fill="#D4A853" />
    <circle cx="36" cy="8" r="1.5" fill="#D4A853" />
    <path d="M25 28 Q30 32 35 28" fill="none" stroke="#FDF6E3" strokeWidth="1" opacity="0.6" />
    <path d="M26 34 Q30 37 34 34" fill="none" stroke="#FDF6E3" strokeWidth="1" opacity="0.6" />
    <defs>
      <linearGradient id="kalashGradient" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#C17817" />
        <stop offset="100%" stopColor="#8B4513" />
      </linearGradient>
    </defs>
  </svg>
);

// Logo Option 2: Elegant "HB" Monogram with Wheat
export const LogoMonogram = ({ className = "w-14 h-14" }) => (
  <svg viewBox="0 0 60 60" className={className}>
    <circle cx="30" cy="30" r="28" fill="url(#monogramGradient)" />
    <circle cx="30" cy="30" r="25" fill="none" stroke="#FDF6E3" strokeWidth="0.5" opacity="0.4" />
    {/* H letter */}
    <path d="M18 18 L18 42 M18 30 L28 30 M28 18 L28 42" fill="none" stroke="#FDF6E3" strokeWidth="2.5" strokeLinecap="round" />
    {/* B letter */}
    <path d="M34 18 L34 42 M34 18 Q44 18 44 24 Q44 30 34 30 Q46 30 46 36 Q46 42 34 42" fill="none" stroke="#FDF6E3" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
    {/* Small wheat accent */}
    <path d="M50 14 Q48 18 50 22" fill="none" stroke="#D4A853" strokeWidth="1.5" strokeLinecap="round" />
    <circle cx="50" cy="12" r="2" fill="#D4A853" />
    <defs>
      <linearGradient id="monogramGradient" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#C17817" />
        <stop offset="100%" stopColor="#8B4513" />
      </linearGradient>
    </defs>
  </svg>
);

// Logo Option 3: Mustard Oil Bottle with Drop
export const LogoOilBottle = ({ className = "w-14 h-14" }) => (
  <svg viewBox="0 0 60 60" className={className}>
    <circle cx="30" cy="30" r="28" fill="url(#bottleGradient)" />
    {/* Bottle shape */}
    <path d="M26 12 L34 12 L34 16 L38 20 L38 46 Q38 50 30 50 Q22 50 22 46 L22 20 L26 16 Z" 
      fill="none" stroke="#FDF6E3" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    {/* Bottle cap */}
    <rect x="27" y="8" width="6" height="4" rx="1" fill="#FDF6E3" opacity="0.8" />
    {/* Oil level line */}
    <path d="M24 26 Q30 28 36 26" fill="none" stroke="#D4A853" strokeWidth="1.5" strokeLinecap="round" />
    {/* Oil drop */}
    <path d="M30 32 Q27 38 30 42 Q33 38 30 32" fill="#D4A853" />
    {/* Decorative dots */}
    <circle cx="30" cy="20" r="1.5" fill="#FDF6E3" opacity="0.5" />
    <defs>
      <linearGradient id="bottleGradient" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#C17817" />
        <stop offset="100%" stopColor="#8B4513" />
      </linearGradient>
    </defs>
  </svg>
);

// Logo Option 4: Traditional Pickle Jar
export const LogoPickleJar = ({ className = "w-14 h-14" }) => (
  <svg viewBox="0 0 60 60" className={className}>
    <circle cx="30" cy="30" r="28" fill="url(#jarGradient)" />
    {/* Jar body */}
    <path d="M20 22 L20 46 Q20 50 30 50 Q40 50 40 46 L40 22 Q40 18 30 18 Q20 18 20 22" 
      fill="none" stroke="#FDF6E3" strokeWidth="2" strokeLinecap="round" />
    {/* Jar lid */}
    <path d="M18 16 L42 16 Q44 16 44 14 Q44 12 42 12 L18 12 Q16 12 16 14 Q16 16 18 16" 
      fill="#FDF6E3" opacity="0.8" />
    {/* Pickles inside */}
    <circle cx="26" cy="32" r="4" fill="none" stroke="#D4A853" strokeWidth="1.5" />
    <circle cx="34" cy="36" r="3.5" fill="none" stroke="#D4A853" strokeWidth="1.5" />
    <circle cx="30" cy="42" r="3" fill="none" stroke="#D4A853" strokeWidth="1.5" />
    {/* Decorative cloth tie */}
    <path d="M22 18 Q30 21 38 18" fill="none" stroke="#D4A853" strokeWidth="1.5" strokeLinecap="round" />
    <defs>
      <linearGradient id="jarGradient" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#C17817" />
        <stop offset="100%" stopColor="#8B4513" />
      </linearGradient>
    </defs>
  </svg>
);

// Logo Option 5: Elegant Shield with Wheat Crown
export const LogoShieldWheat = ({ className = "w-14 h-14" }) => (
  <svg viewBox="0 0 60 60" className={className}>
    <circle cx="30" cy="30" r="28" fill="url(#shieldGradient)" />
    {/* Shield shape */}
    <path d="M30 10 L44 16 L44 34 Q44 46 30 52 Q16 46 16 34 L16 16 Z" 
      fill="none" stroke="#FDF6E3" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    {/* Inner shield design */}
    <path d="M30 16 L38 20 L38 32 Q38 40 30 44 Q22 40 22 32 L22 20 Z" 
      fill="none" stroke="#FDF6E3" strokeWidth="1" opacity="0.5" />
    {/* Wheat crown on top */}
    <path d="M24 8 Q26 6 24 4" fill="none" stroke="#D4A853" strokeWidth="1.5" strokeLinecap="round" />
    <path d="M30 8 Q30 5 30 2" fill="none" stroke="#D4A853" strokeWidth="1.5" strokeLinecap="round" />
    <path d="M36 8 Q34 6 36 4" fill="none" stroke="#D4A853" strokeWidth="1.5" strokeLinecap="round" />
    <circle cx="24" cy="4" r="1.5" fill="#D4A853" />
    <circle cx="30" cy="2" r="1.5" fill="#D4A853" />
    <circle cx="36" cy="4" r="1.5" fill="#D4A853" />
    {/* H letter in center */}
    <text x="30" y="36" textAnchor="middle" fill="#FDF6E3" fontSize="16" fontFamily="serif" fontWeight="bold">H</text>
    <defs>
      <linearGradient id="shieldGradient" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#C17817" />
        <stop offset="100%" stopColor="#8B4513" />
      </linearGradient>
    </defs>
  </svg>
);

// Logo Option 6: Minimal Circle with Stylized "H"
export const LogoMinimalH = ({ className = "w-14 h-14" }) => (
  <svg viewBox="0 0 60 60" className={className}>
    <circle cx="30" cy="30" r="28" fill="url(#minimalGradient)" />
    <circle cx="30" cy="30" r="24" fill="none" stroke="#FDF6E3" strokeWidth="1" opacity="0.3" />
    {/* Stylized H with curves */}
    <path d="M20 16 L20 44" fill="none" stroke="#FDF6E3" strokeWidth="3" strokeLinecap="round" />
    <path d="M40 16 L40 44" fill="none" stroke="#FDF6E3" strokeWidth="3" strokeLinecap="round" />
    <path d="M20 30 Q30 24 40 30" fill="none" stroke="#D4A853" strokeWidth="3" strokeLinecap="round" />
    {/* Small decorative dots */}
    <circle cx="20" cy="14" r="2" fill="#D4A853" />
    <circle cx="40" cy="14" r="2" fill="#D4A853" />
    <defs>
      <linearGradient id="minimalGradient" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#C17817" />
        <stop offset="100%" stopColor="#8B4513" />
      </linearGradient>
    </defs>
  </svg>
);

export default { LogoKalash, LogoMonogram, LogoOilBottle, LogoPickleJar, LogoShieldWheat, LogoMinimalH };
